export default "__VITE_ASSET__DRo1AhYK__"